import axiosInstance from '@/utils/api.js'

var state = {
  payments: []
}

var getters = {
  PAYMENT_ORDERS: (state) => {
    return state.payments
  }
}

var mutations = {
  SET_PAYMENT_ORDER: (state, payload) => {
    state.payments = payload
  }
}

var actions = {
  GET_PAYMENT_ORDERS: async (context, payload) => {
    let result = await axiosInstance.get('/reports/payment_orders?start=' + payload.numDateStart +
    '&end=' + payload.numDateEnd +
    '&user_id=' + payload.userId +
    '&account_id=0&accounting_period_id=0' +
    '&group_id=' + payload.group_id +
    '&accs_group_id=' + payload.accs_group_id +
    '&limit=' + payload.limit +
    '&download=' + payload.download, {timeout: 45000})
    if (result.status === 200) {
      context.commit('SET_PAYMENT_ORDER', result.data)
    }
  },
  CLEAR_PAYMENT_ORDERS: (context) => {
    context.commit('SET_PAYMENT_ORDER', [])
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/reports/paymentOrders.js